import includes from 'lodash/includes'
import type { OrderPaymentStatusEnum } from '@ztechapps/common.contract'
import { OrderStatusEnum } from '@ztechapps/common.contract'
import { isPaymentOutstanding } from './isPaymentOutstanding'

/**
 * True once an order has left the warehouse (InTransit, Shipped or Delivered) with money still outstanding, so the
 * customer may pay the remaining balance after shipment — the store's PayBalanceButton also needs that balance above
 * STRIPE_CARD_MINIMUM.
 */
export const isPostShipmentPayable = (status: OrderStatusEnum, paymentStatus: OrderPaymentStatusEnum): boolean =>
  includes([OrderStatusEnum.InTransit, OrderStatusEnum.Shipped, OrderStatusEnum.Delivered], status) &&
  isPaymentOutstanding(paymentStatus)
